export default __webpack_public_path__ + "static/media/BrainBreak cards9.580d33f1.png";